import Select from "react-select";
import DatePicker from "react-datepicker";

function toDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

function toDateString(date) {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: state.isFocused ? "#1B3F6E" : "#CFD8DC",
    borderWidth: 1.5,
    borderRadius: 8,
    boxShadow: "none",
    fontSize: 13,
    fontFamily: "inherit",
    "&:hover": { borderColor: state.isFocused ? "#1B3F6E" : "#B0BEC5" },
  }),
  menu: base => ({ ...base, zIndex: 30 }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#1B3F6E" : state.isFocused ? "#EBF5FB" : "#fff",
    color: state.isSelected ? "#fff" : "#1a1a1a",
    fontSize: 13,
  }),
  singleValue: base => ({ ...base, color: "#1a1a1a" }),
  placeholder: base => ({ ...base, color: "#90A4AE" }),
};

export function AppSelect({ value, onChange, options, placeholder = "Select...", isClearable = false, isDisabled = false, style }) {
  const selected = options.find(option => option.value === value) || null;

  return (
    <div style={style}>
      <Select
        value={selected}
        onChange={option => onChange(option?.value || "")}
        options={options}
        placeholder={placeholder}
        isClearable={isClearable}
        isDisabled={isDisabled}
        styles={selectStyles}
        menuPortalTarget={document.body}
      />
    </div>
  );
}

export function AppDatePicker({ value, onChange, placeholder = "Select date", maxDate, style }) {
  return (
    <div style={style}>
      <DatePicker
        selected={toDate(value)}
        onChange={date => onChange(toDateString(date))}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        maxDate={maxDate}
        className="ts360-date-picker"
        wrapperClassName="ts360-date-picker-wrap"
        popperClassName="ts360-date-picker-popper"
        isClearable
      />
    </div>
  );
}
